import { motion, AnimatePresence } from 'framer-motion';
import { useLocation } from 'react-router-dom';
import Sidebar from '../dashboard/Sidebar';
import AIChatButton from '../common/AIChatButton';
import './DashboardLayout.css';

const DashboardLayout = ({ children }) => {
  const location = useLocation();

  return (
    <>
      <Sidebar />
      
      <div className="dashboard-main">
        <AnimatePresence mode="wait">
          <motion.div 
            key={location.pathname}
            className="dashboard-content"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
          >
            {children}
          </motion.div>
        </AnimatePresence>
        <AIChatButton />
      </div>
    </>
  );
};

export default DashboardLayout;